import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {APIService} from "./api.service";
import {IGamePayoutRuleQueryResult} from "../interfaces/payout-rule/IGamePayoutRuleQueryResult";
import {ISetGamePayoutRuleCommand} from "../interfaces/commands/ISetGamePayoutRuleCommand";
import {IVoidGamePayoutRuleCommand} from "../interfaces/commands/IVoidGamePayoutRuleCommand";

@Injectable({
  providedIn: 'root'
})
export class GamePayoutRuleService {

  constructor(private apiService: APIService) {
  }

  /**
   * The rule and the administration fee rate its shares divide. `Rule` is null when the game has no rule
   * configured — the normal state, not an error.
   */
  public fetchByGameId(gameIdP: string): Observable<IGamePayoutRuleQueryResult> {
    return this.apiService.MakeGetRequest<IGamePayoutRuleQueryResult>(`game-payout-rule/by-game/${gameIdP}`);
  }

  public setPayoutRule(commandP: ISetGamePayoutRuleCommand): Observable<void> {
    return this.apiService.MakePutRequest<void>('game-payout-rule', commandP);
  }

  /** Causable admins only. */
  public voidPayoutRule(commandP: IVoidGamePayoutRuleCommand): Observable<void> {
    return this.apiService.MakePostRequest<void>('game-payout-rule/void', commandP);
  }
}
